const CHAR_NO_BREAK_SPACE = '\u00A0';
export function getThousandSeparator(locale: string): string {
  return (
    Intl.NumberFormat(locale)
      .formatToParts(1000)
      .find((part) => part.type === 'group')?.value || CHAR_NO_BREAK_SPACE
  );
}
